import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Overlay from './Overlay';
import OverlayCloseButton from './OverlayCloseButton';

function Modal ({
	'aria-hidden': ariaHidden,
	'aria-label': ariaLabel,
	children,
	className,
	escapeExits,
	hideOverlay,
	show,
	showCloseButton,
	showUnderlay,
	underlayClickExits,
	focusDialog,
	initialFocus,
	scrollDisabled,
	greyBackground,
	focusTrapPaused = false,
	underlayClickExitHandler
}) {

	const modalClassNames = classNames('Overlay--Modal', className);

	return (
		<Overlay
			aria-hidden={ariaHidden}
			aria-label={ariaLabel}
			className={modalClassNames}
			escapeExits={escapeExits}
			hideOverlay={hideOverlay}
			show={show}
			showCloseButton={showCloseButton}
			showUnderlay={showUnderlay}
			underlayClickExits={underlayClickExits}
			focusDialog={focusDialog}
			initialFocus={initialFocus}
			scrollDisabled={scrollDisabled}
			focusTrapPaused={focusTrapPaused}
			underlayClickExitHandler={underlayClickExitHandler}
		>
			{showCloseButton && (
				<div
					className={classNames('Overlay__contentWrapper__closeButtonContainer', {
						'Overlay__contentWrapper__closeButtonContainer--grey': greyBackground
					})}
				>
					<OverlayCloseButton hideOverlay={hideOverlay} />
				</div>
			)}
			{children}
		</Overlay>
	);

}
Modal.defaultProps = {
	'aria-hidden': false,
	showCloseButton: true,
	showUnderlay: true,
	underlayClickExits: true,
	focusDialog: true,
	initialFocus: undefined,
	scrollDisabled: true,
	greyBackground: false
};

Modal.propTypes = {
	'aria-label': PropTypes.string.isRequired,
	'aria-hidden': PropTypes.bool,
	children: PropTypes.oneOfType([ PropTypes.node, PropTypes.arrayOf(PropTypes.node) ]).isRequired,
	className: PropTypes.string,
	escapeExits: PropTypes.bool.isRequired,
	hideOverlay: PropTypes.func.isRequired,
	show: PropTypes.bool.isRequired,
	showCloseButton: PropTypes.bool,
	showUnderlay: PropTypes.bool,
	underlayClickExits: PropTypes.bool,
	focusDialog: PropTypes.bool,
	initialFocus: PropTypes.oneOfType([ PropTypes.node, PropTypes.string, PropTypes.func, PropTypes.bool ]),
	scrollDisabled: PropTypes.bool,
	greyBackground: PropTypes.bool,
	focusTrapPaused: PropTypes.bool,
	underlayClickExitHandler: PropTypes.func

};

export default Modal;
